import React, { Component, ChangeEvent, FormEvent } from 'react'
import { t, Trans } from '@lingui/macro'
import { isEmpty } from 'lodash'

import './YoutubeVideoInput.less'
import { ButtonPrimary } from 'front-end/src/components'
import IconSocialYoutube from '../../../../../../../components/common/icon/IconSocialYoutube'

interface IProps {
  onSave: (url: string) => void
}

interface IState {
  url: string
  isValid?: boolean
}

class YoutubeVideoInput extends Component<IProps, IState> {
  state: IState = {
    url: ''
  }

  handleSubmit = (ev: FormEvent) => {
    ev.preventDefault()

    const { isValid, url } = this.state
    if (!isValid) {
      return
    }

    const { onSave } = this.props
    onSave(url)
  }

  handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const url = ev.currentTarget.value
    const isValid = !isEmpty(url)

    this.setState({ isValid, url })
  }

  render() {
    const { isValid } = this.state

    return (
      <div className="YoutubeVideoInput">
        <form onSubmit={this.handleSubmit}>
          <a
            className="YoutubeButton"
            href="http://www.youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            title={t`Open YouTube in a new tab`}
          >
            <IconSocialYoutube />
          </a>
          <input
            className="Input"
            type="text"
            placeholder={t`or paste a link from YouTube, Vimeo, SoundCloud or Wistia here`}
            onChange={this.handleChange}
          />
          {isValid && (
            <ButtonPrimary type="submit">
              <Trans>Save</Trans>
            </ButtonPrimary>
          )}
        </form>
      </div>
    )
  }
}

export default YoutubeVideoInput
